import { ScheduleSettingsClient } from './schedule-settings-client';
export default function ScheduleSettingsPage() { return <ScheduleSettingsClient />; }
